import React, { useRef, useState } from 'react';

import { ContextInput } from '../../Tabs/Collaborators/components/ContextInput/ContextInput';
import useClickOutside from 'hooks/useClickOutside';
import {
	Container,
	ContainerHeader,
	ContainerContent,
	ContainerSelect,
} from './ContextMenuContainer.styles';

interface ContextMenuContainerProps {
	selectedCommunication: any;
	communications: any;
	onSelectCommunication: (Number: number) => void;
}

export const ContextMenuContainer = ({
	selectedCommunication,
	communications,
	onSelectCommunication,
}: ContextMenuContainerProps) => {
	const [isOpen, setOpen] = useState(false);
	const refContainer = useRef<any>(null);

	const handleToggleOpen = () => setOpen(!isOpen);

	const handleClose = () => setOpen(false);

	useClickOutside({ ref: refContainer, onClose: handleClose });

	const handleSelectCommunication = (number: number) => {
		onSelectCommunication(number);
		handleClose();
	};

	if (!communications.length) {
		return null;
	}

	return (
		<Container ref={refContainer}>
			<ContainerHeader onClick={handleToggleOpen}>
				<ContextInput isOpen={isOpen} reference={selectedCommunication} />
			</ContainerHeader>
			{isOpen && (
				<ContainerContent>
					{communications.map((communication: any, index: number) => (
						<ContainerSelect
							onClick={() => handleSelectCommunication(index)}
							key={communication.id}
						>
							<ContextInput reference={communication} isOption />
						</ContainerSelect>
					))}
				</ContainerContent>
			)}
		</Container>
	);
};
